import React, { useState } from 'react';
import { AlertTriangle, Mail, X, Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import apiClient from '../services/api';
import { toast } from 'sonner';

const EmailVerificationBanner = () => {
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  if (user.email_verified || user.email_verified === undefined || dismissed) return null;

  const handleResend = async () => {
    setSending(true);
    try {
      await apiClient.post('/auth/resend-verification');
      toast.success('Verification email sent! Check your inbox.');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to send verification email');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-2.5 flex items-center justify-between gap-3" data-testid="email-verification-banner">
      <div className="flex items-center gap-2 min-w-0">
        <AlertTriangle className="w-4 h-4 text-amber-600 shrink-0" />
        <p className="text-sm text-amber-800 truncate">
          Please verify your email address to get full access to all features.
        </p>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <Button
          size="sm"
          variant="outline"
          className="h-7 text-xs bg-[#5FD068] hover:bg-[#4ec057] text-white border-0"
          onClick={handleResend}
          disabled={sending}
          data-testid="resend-verification-btn"
        >
          {sending ? <Loader2 className="w-3 h-3 mr-1 animate-spin" /> : <Mail className="w-3 h-3 mr-1" />}
          Resend
        </Button>
        <button onClick={() => setDismissed(true)} className="text-amber-500 hover:text-amber-700">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default EmailVerificationBanner;
